@let seatIcon = getIconForServiceCategory(Category.SEAT);
@let plusIcon = SvgLibraryIcon.PLUS;
@let categoryIcon = getIconForServiceCategory(this.category);

<div
  class="seat-bundle-toggle-container rounded-large border ms-medium-b overflow-hidden"
  [class.heather-600-border]="active"
  aria-live="polite"
>
  <div class="flex flex--space-between wrap white-bg" data-testid="seat-bundle-toggle-inner-container">
    <div class="heather-700-bg flex flex--self-stretch flex--center ps-xsmall icon-container">
      <fcom-icon class="icon-medium white-text flex--self-center" [name]="seatIcon" />
      <fcom-icon class="icon-small white-text flex--self-center" [name]="plusIcon" />
      <fcom-icon class="icon-medium white-text flex--self-center" [name]="categoryIcon" />
    </div>

    <div class="flex flex--basis-full ps-small rounded-top-large rounded-bottom-large">
      <div class="flex flex--column flex--basis-full text-container">
        <div class="flex--inline">
          <p>
            <span class="font-body-1 bold-type ps-xsmall-r" data-testid="seat-bundle-toggle-combo-title-text">
              {{ `ancillaries.${category}.offersToggle.title.${subCategoryForTranslations}` | finLocalization }}
            </span>
          </p>
        </div>
        <div class="toggle-footer flex">
          <p class="font-body-2 ps-xsmall-y" data-testid="seat-bundle-toggle-description">
            {{ `ancillaries.${category}.offersToggle.description.${subCategoryForTranslations}` | finLocalization }}
          </p>
          <fcom-button
            class="flex--self-end"
            data-testid="bundle-offers-toggle"
            [theme]="active ? ButtonTheme.LIGHT_SECONDARY_OUTLINE : ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
            [icon]="active ? { name: SvgLibraryIcon.CHECKMARK, position: IconPosition.LEFT } : null"
            [text]="
              active
                ? ('ancillaries.bundle.toggle.buttonText.showingCombos' | finLocalization)
                : ('ancillaries.bundle.toggle.buttonText.showCombos' | finLocalization)
            "
            (clickBtn)="emitToggle(!active)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
